module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.success) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._t("default", [_c('p', [_vm._v(_vm._s(_vm.success))])])], 2) : (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._t("default", [_c('p', [_vm._v(_vm._s(_vm.error))])])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00291a4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = 772
// module chunks = 1